import { ShiftsLocationFilter } from '../shifts-location-filter/shifts-location-filter'
import { ShiftsDesignationFilter } from '../shifts-designation-filter/shifts-designation-filter'
import './shifts-filters.scss'

type Props = {
  onChange: () => void
}

export const ShiftsFilters = ({ onChange }: Props) => (
  <div className="ShiftsFilters">
    <ShiftsLocationFilter onLocationChange={onChange} />
    <ShiftsDesignationFilter onDesignationChange={onChange} />
  </div>
)
